import { stats } from '@/data/stats';
import { motion } from 'framer-motion';
import { Container } from '@/components/ui/container';
import { CheckCircle, Code, User, Rocket } from 'lucide-react';

export default function LandingStats(): JSX.Element {
	const icons = [CheckCircle, Code, User, Rocket];

	return (
		<Container className="max-w-5xl">
			<div className="absolute inset-0 jupiter-gradient opacity-5"></div>
			<div className="grid grid-cols-2 md:grid-cols-4 gap-8">
				{stats.map((stat, index) => {
					const Icon = icons[index];
					return (
						<motion.div
							key={stat.label}
							initial={{ opacity: 0, y: 20 }}
							animate={{ opacity: 1, y: 0 }}
							transition={{ duration: 0.5, delay: index * 0.1 }}
							className="text-center p-6 rounded-xl bg-gradient-to-b from-foreground/5 to-transparent border border-foreground/10 hover:border-primary/20 transition-all duration-300 group"
						>
							<div className="flex justify-center mb-4">
								<Icon className="w-8 h-8 text-red-500/60 group-hover:text-orange-500 transition-colors duration-300" />
							</div>
							<p className="text-5xl md:text-6xl font-bold text-orange-500 mb-3 group-hover:scale-105 transition-transform duration-300">
								{stat.value}
							</p>
							<p className="text-lg text-muted-foreground group-hover:text-orange-500/80 transition-colors duration-300">
								{stat.label}
							</p>
						</motion.div>
					);
				})}
			</div>
		</Container>
	);
}
